import assertNever from "../../global/assetNever";

export enum ObjectModelRelationType {
  OneToOne = 1,
  OneToMany = 2,
  ManyToOne = 3,
  Account = 4,
  EntityAccount = 5,
}

export const ObjectModelSingleRelations: Array<ObjectModelRelationType> = [ObjectModelRelationType.OneToOne, ObjectModelRelationType.ManyToOne];

export function friendlyObjectRelationDisplay(type: ObjectModelRelationType, inverse = false): string {
  if ([null, undefined].includes(type)) return "";
  let result: string;

  if (!inverse) {
    switch(type) {
      case ObjectModelRelationType.OneToMany:
        result = "Has Many";
        break;
      case ObjectModelRelationType.OneToOne:
        result = "Has One";
        break;
      case ObjectModelRelationType.ManyToOne:
        result = "Has One";
        break;
      case ObjectModelRelationType.Account:
        result = "Account";
        break;
      case ObjectModelRelationType.EntityAccount:
        result = "Entity Account";
        break;
      default:
        assertNever(type);
        break;
    }
    return result;
  }

  switch(type) {
    case ObjectModelRelationType.OneToMany:
      result = "Has One";
      break;
    case ObjectModelRelationType.OneToOne:
      result = "Has One";
      break;
    case ObjectModelRelationType.ManyToOne:
      result = "Has Many";
      break;
    case ObjectModelRelationType.Account:
      result = "Account";
      break;
    case ObjectModelRelationType.EntityAccount:
      result = "Entity Account";
      break;
    default:
      assertNever(type);
      break;
  }
  return result;

 
}

export function strictObjectRelationDisplay(type: ObjectModelRelationType): string {
  return ObjectModelRelationType[type].replace(/([A-Z])/g, ' $1');
}

